import {Injectable} from '@angular/core';
import {UserService} from './user.service';
import {StandardQuestionModel} from '../models/standard-question.model';
import {Question} from '../models/question.model';
import {Answer} from '../models/answer.model';
import {ResponsedQuestions} from '../models/responsed-questions.model';


@Injectable()
export class TestingService {
  questionsList: StandardQuestionModel[] = null;
  selectedAllAnswers = false;
  buttonLabel = 'CHECK_ANSWERS';
  answersDone = false;
  answeredQuestions: Map<Question, Answer> = new Map();
  responsedQuestions: ResponsedQuestions;
  leaveTesting = false;

  constructor(private userService: UserService) {
  }

  getResponsedQuestions() {
    return this.responsedQuestions;
  }

  setResponsedQuestions(rq) {
    this.responsedQuestions = rq;
  }

  getQuestionsAPI() {
    return this.userService.getQuestions();
  }

  getQuestions() {
    return this.questionsList;
  }

  setQuestions(qList) {
    this.questionsList = qList;
  }

  getSelectedAllAnswers() {
    return this.selectedAllAnswers;
  }

  setSelectedAllAnswers(f) {
    this.selectedAllAnswers = f;
  }

  getButtonLabel() {
    return this.buttonLabel;
  }

  setButtonLabel(btnLabel) {
    this.buttonLabel = btnLabel;
  }

  getAnswersDone() {
    return this.answersDone;
  }

  setAnswersDone(f) {
    this.answersDone = f;
  }

  getAnsweredQuestions() {
    return this.answeredQuestions;
  }

  addToAnsweredQuestions(question, answer) {
    this.answeredQuestions.set(question, answer);

    if (this.answeredQuestions.size !== null && this.questionsList !== null) {
      if (this.answeredQuestions.size === this.questionsList.length) {
        this.selectedAllAnswers = true;
      }
    }

  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/testing.service.ts